/** Retourne l'emoji drapeau correspondant à la langue du navigateur. */
export function getLanguageFlag(): string {
  const lang = (navigator.language || 'fr').split('-')[0].toLowerCase();
  const FLAGS: Record<string, string> = {
    fr: '🇫🇷',
    en: '🇬🇧',
    de: '🇩🇪',
    es: '🇪🇸',
    it: '🇮🇹',
    nl: '🇳🇱',
    pt: '🇵🇹',
    pl: '🇵🇱',
    sv: '🇸🇪',
    da: '🇩🇰',
    fi: '🇫🇮',
    nb: '🇳🇴',
    no: '🇳🇴',
    cs: '🇨🇿',
    sk: '🇸🇰',
    hu: '🇭🇺',
    ro: '🇷🇴',
    bg: '🇧🇬',
    hr: '🇭🇷',
    el: '🇬🇷',
  };
  return FLAGS[lang] ?? '🌍';
}
